module.exports = __webpack_public_path__ + "img/check-example.ab5dd233.jpg";